import { render, staticRenderFns } from "./BasicLayout.vue?vue&type=template&id=3af013f6&scoped=true&"
import script from "./BasicLayout.vue?vue&type=script&lang=js&"
export * from "./BasicLayout.vue?vue&type=script&lang=js&"
import style0 from "./BasicLayout.vue?vue&type=style&index=0&id=3af013f6&prod&lang=scss&scoped=true&"
import style1 from "./BasicLayout.vue?vue&type=style&index=1&id=3af013f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af013f6",
  null
  
)

export default component.exports